import { Loader as MantineLoader } from "@mantine/core";

export function Loader() {
  return <MantineLoader />;
}
